import { userHasProOrPlusTier } from '@wetransfer/transfer/helper/user';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';
import { Pricing } from '@wetransfer/transfer/store/types';

export const getYearlyDiscountRate = (tier: Pricing): number => {
  const month = tier.month.total_cents_per_seat;
  const monthTotal = month * 12;
  const yearTotal = tier.year.total_cents_per_seat;

  if (!monthTotal || !yearTotal) {
    return 17; // Fallback to default 17% yearly discount
  }

  // Yearly pricing should not equal or be higher than pricing for 12 recurring months
  if (yearTotal >= monthTotal) {
    ErrorHandler.track({
      name: 'InvalidYearlyDiscount',
      message: `yearly pricing (${yearTotal}) equals or is higher than pricing for 12 recurring months (${month})`,
      stack: 'init/pricing',
    });

    return 17; // Fallback to default 17% yearly discount
  }

  return Math.round(((monthTotal - yearTotal) / monthTotal) * 100);
};

export const getAnalyticsProperty = (user: any) => {
  const property = user.planTier ? user.planTier + '_account' : 'anonymous';

  return property;
};

export const getCurrentTierAnalyticsProperty = (
  user: any,
  target: string
): string => {
  if (!user.planTier) return `sign_up_anonymous_to_${target}`;

  if (userHasProOrPlusTier(user)) return `upgrade_from_pro_to_${target}`;

  return `upgrade_from_${user.planTier}_to_${target}`;
};
